import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CardFooter } from '@/shared/ui/card'
import { Label } from '@/shared/ui/label'
import { Input } from '@/shared/ui/input'
import { Button } from '@/shared/ui/button'
import resetIcon from '@/images/SVG/resrtPass.svg'
import { toast } from 'react-toastify'
import { AuthWrapper } from '@/shared/components/CardWrapper'
import { useTranslation } from 'react-i18next';
import { requestPasswordReset } from '@/features/auth/lib/resetPassword'

const ForgotPass = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(''); 
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleResetPassword = async () => {
    if (!email) {
      toast.error(`${t('auth.enterEmail')}`);
      return;
    }
    setLoading(true);
    try {
      const output = await requestPasswordReset(email);
      if (output.nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE') {
        toast.success(`${t('auth.verificationCodeSent')}`);
        navigate('/verify-password', { state: { email } });
      } else if (output.nextStep.resetPasswordStep === 'DONE') {
        console.log('Password reset successfully');
      }
    } catch (err) {
      switch(err.message) {
        case 'Username/client id combination not found.':
          toast.error(`${t('auth.enterValidEmail')}`);
          break;
        default:
          toast.error(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthWrapper icon={resetIcon} heading={t('auth.resetPasswordHeading')} forgetPass>
        <div className="flex flex-col space-y-1.5">
          <Label htmlFor="email" className="font-semibold text-left mt-5">{t('common.email')}</Label>
          <Input
            className="text-[#868C98] font-normal "
            id="email"
            placeholder={t('auth.enterEmail')}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
      <CardFooter className="flex justify-center w-full flex-col p-0 mt-5">
        <Button
          variant="default"
          className="w-full "
          onClick={handleResetPassword}
          disabled={loading}
        >
          {t('auth.resetPasswordButton')}
        </Button>
        <p className='text-[14px] font-normal mt-2 text-[#09090B]'>{t('auth.changedYourMind')} <span onClick={() => navigate(-1)} className='text-black font-semibold underline cursor-pointer underline-offset-2'>{t('auth.goBack')}</span></p>
      </CardFooter>
    </AuthWrapper>
  );
};

export default ForgotPass;